@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-194_204_557)
internal val Res.drawable.M26: DrawableResource by lazy {
      DrawableResource("drawable:M26", setOf(
        ResourceItem(setOf(), "${MD}drawable/M26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-608_227_269)
internal val Res.drawable.M27: DrawableResource by lazy {
      DrawableResource("drawable:M27", setOf(
        ResourceItem(setOf(), "${MD}drawable/M27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_087_549_457)
internal val Res.drawable.M28: DrawableResource by lazy {
      DrawableResource("drawable:M28", setOf(
        ResourceItem(setOf(), "${MD}drawable/M28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_451_213_521)
internal val Res.drawable.M28A: DrawableResource by lazy {
      DrawableResource("drawable:M28A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M28A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_286_306_414)
internal val Res.drawable.M29: DrawableResource by lazy {
      DrawableResource("drawable:M29", setOf(
        ResourceItem(setOf(), "${MD}drawable/M29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_108_197_425)
internal val Res.drawable.M3: DrawableResource by lazy {
      DrawableResource("drawable:M3", setOf(
        ResourceItem(setOf(), "${MD}drawable/M3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(126_094_760)
internal val Res.drawable.M30: DrawableResource by lazy {
      DrawableResource("drawable:M30", setOf(
        ResourceItem(setOf(), "${MD}drawable/M30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-878_042_892)
internal val Res.drawable.M31: DrawableResource by lazy {
      DrawableResource("drawable:M31", setOf(
        ResourceItem(setOf(), "${MD}drawable/M31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-308_592_024)
internal val Res.drawable.M31A: DrawableResource by lazy {
      DrawableResource("drawable:M31A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M31A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_110_162_025)
internal val Res.drawable.M32: DrawableResource by lazy {
      DrawableResource("drawable:M32", setOf(
        ResourceItem(setOf(), "${MD}drawable/M32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_320_108_228)
internal val Res.drawable.M33: DrawableResource by lazy {
      DrawableResource("drawable:M33", setOf(
        ResourceItem(setOf(), "${MD}drawable/M33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(614_516_676)
internal val Res.drawable.M33A: DrawableResource by lazy {
      DrawableResource("drawable:M33A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M33A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_150_097_076)
internal val Res.drawable.M33B: DrawableResource by lazy {
      DrawableResource("drawable:M33B", setOf(
        ResourceItem(setOf(), "${MD}drawable/M33B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_924_507_044)
internal val Res.drawable.M34: DrawableResource by lazy {
      DrawableResource("drawable:M34", setOf(
        ResourceItem(setOf(), "${MD}drawable/M34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_329_132_551)
internal val Res.drawable.M35: DrawableResource by lazy {
      DrawableResource("drawable:M35", setOf(
        ResourceItem(setOf(), "${MD}drawable/M35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_861_242_707)
internal val Res.drawable.M36: DrawableResource by lazy {
      DrawableResource("drawable:M36", setOf(
        ResourceItem(setOf(), "${MD}drawable/M36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(121_511_529)
internal val Res.drawable.M37: DrawableResource by lazy {
      DrawableResource("drawable:M37", setOf(
        ResourceItem(setOf(), "${MD}drawable/M37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(652_852_343)
internal val Res.drawable.M38: DrawableResource by lazy {
      DrawableResource("drawable:M38", setOf(
        ResourceItem(setOf(), "${MD}drawable/M38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(869_444_793)
internal val Res.drawable.M39: DrawableResource by lazy {
      DrawableResource("drawable:M39", setOf(
        ResourceItem(setOf(), "${MD}drawable/M39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_365_101_000)
internal val Res.drawable.M3A: DrawableResource by lazy {
      DrawableResource("drawable:M3A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M3A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_138_863_958)
internal val Res.drawable.M4: DrawableResource by lazy {
      DrawableResource("drawable:M4", setOf(
        ResourceItem(setOf(), "${MD}drawable/M4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_083_738_616)
internal val Res.drawable.M40: DrawableResource by lazy {
      DrawableResource("drawable:M40", setOf(
        ResourceItem(setOf(), "${MD}drawable/M40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-176_053_221)
internal val Res.drawable.M40A: DrawableResource by lazy {
      DrawableResource("drawable:M40A", setOf(
        ResourceItem(setOf(), "${MD}drawable/M40A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(784_110_436)
internal val Res.drawable.M41: DrawableResource by lazy {
      DrawableResource("drawable:M41", setOf(
        ResourceItem(setOf(), "${MD}drawable/M41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-645_764_637)
internal val Res.drawable.M42: DrawableResource by lazy {
      DrawableResource("drawable:M42", setOf(
        ResourceItem(setOf(), "${MD}drawable/M42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_997_395_243)
internal val Res.drawable.M43: DrawableResource by lazy {
      DrawableResource("drawable:M43", setOf(
        ResourceItem(setOf(), "${MD}drawable/M43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(779_160_634)
internal val Res.drawable.M44: DrawableResource by lazy {
      DrawableResource("drawable:M44", setOf(
        ResourceItem(setOf(), "${MD}drawable/M44.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_579_142_182)
internal val Res.drawable.M5: DrawableResource by lazy {
      DrawableResource("drawable:M5", setOf(
        ResourceItem(setOf(), "${MD}drawable/M5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_764_299_727)
internal val Res.drawable.M6: DrawableResource by lazy {
      DrawableResource("drawable:M6", setOf(
        ResourceItem(setOf(), "${MD}drawable/M6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_361_101_360)
internal val Res.drawable.M7: DrawableResource by lazy {
      DrawableResource("drawable:M7", setOf(
        ResourceItem(setOf(), "${MD}drawable/M7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(588_922_611)
internal val Res.drawable.M8: DrawableResource by lazy {
      DrawableResource("drawable:M8", setOf(
        ResourceItem(setOf(), "${MD}drawable/M8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_463_352_456)
internal val Res.drawable.M9: DrawableResource by lazy {
      DrawableResource("drawable:M9", setOf(
        ResourceItem(setOf(), "${MD}drawable/M9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(112_349_372)
internal val Res.drawable.N1: DrawableResource by lazy {
      DrawableResource("drawable:N1", setOf(
        ResourceItem(setOf(), "${MD}drawable/N1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-311_823_042)
internal val Res.drawable.N10: DrawableResource by lazy {
      DrawableResource("drawable:N10", setOf(
        ResourceItem(setOf(), "${MD}drawable/N10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(718_069_176)
internal val Res.drawable.N11: DrawableResource by lazy {
      DrawableResource("drawable:N11", setOf(
        ResourceItem(setOf(), "${MD}drawable/N11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_227_709_989)
internal val Res.drawable.N12: DrawableResource by lazy {
      DrawableResource("drawable:N12", setOf(
        ResourceItem(setOf(), "${MD}drawable/N12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-809_740_249)
internal val Res.drawable.N13: DrawableResource by lazy {
      DrawableResource("drawable:N13", setOf(
        ResourceItem(setOf(), "${MD}drawable/N13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(690_492_263)
internal val Res.drawable.N14: DrawableResource by lazy {
      DrawableResource("drawable:N14", setOf(
        ResourceItem(setOf(), "${MD}drawable/N14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(958_722_137)
internal val Res.drawable.N15: DrawableResource by lazy {
      DrawableResource("drawable:N15", setOf(
        ResourceItem(setOf(), "${MD}drawable/N15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-915_662_575)
internal val Res.drawable.N16: DrawableResource by lazy {
      DrawableResource("drawable:N16", setOf(
        ResourceItem(setOf(), "${MD}drawable/N16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_208_943_825)
internal val Res.drawable.N17: DrawableResource by lazy {
      DrawableResource("drawable:N17", setOf(
        ResourceItem(setOf(), "${MD}drawable/N17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-318_720_272)
internal val Res.drawable.N18: DrawableResource by lazy {
      DrawableResource("drawable:N18", setOf(
        ResourceItem(setOf(), "${MD}drawable/N18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(247_926_114)
internal val Res.drawable.N18A: DrawableResource by lazy {
      DrawableResource("drawable:N18A", setOf(
        ResourceItem(setOf(), "${MD}drawable/N18A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_002_737_741)
internal val Res.drawable.N18B: DrawableResource by lazy {
      DrawableResource("drawable:N18B", setOf(
        ResourceItem(setOf(), "${MD}drawable/N18B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_019_989_219)
internal val Res.drawable.N19: DrawableResource by lazy {
      DrawableResource("drawable:N19", setOf(
        ResourceItem(setOf(), "${MD}drawable/N19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_075_903_548)
internal val Res.drawable.N2: DrawableResource by lazy {
      DrawableResource("drawable:N2", setOf(
        ResourceItem(setOf(), "${MD}drawable/N2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_285_267_834)
internal val Res.drawable.N20: DrawableResource by lazy {
      DrawableResource("drawable:N20", setOf(
        ResourceItem(setOf(), "${MD}drawable/N20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_032_289_128)
internal val Res.drawable.N21: DrawableResource by lazy {
      DrawableResource("drawable:N21", setOf(
        ResourceItem(setOf(), "${MD}drawable/N21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_712_996_346)
internal val Res.drawable.N22: DrawableResource by lazy {
      DrawableResource("drawable:N22", setOf(
        ResourceItem(setOf(), "${MD}drawable/N22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_640_772_979)
internal val Res.drawable.N23: DrawableResource by lazy {
      DrawableResource("drawable:N23", setOf(
        ResourceItem(setOf(), "${MD}drawable/N23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_826_201_541)
internal val Res.drawable.N24: DrawableResource by lazy {
      DrawableResource("drawable:N24", setOf(
        ResourceItem(setOf(), "${MD}drawable/N24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(665_251_793)
internal val Res.drawable.N25: DrawableResource by lazy {
      DrawableResource("drawable:N25", setOf(
        ResourceItem(setOf(), "${MD}drawable/N25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_139_037_389)
internal val Res.drawable.N25A: DrawableResource by lazy {
      DrawableResource("drawable:N25A", setOf(
        ResourceItem(setOf(), "${MD}drawable/N25A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_714_213_274)
internal val Res.drawable.N26: DrawableResource by lazy {
      DrawableResource("drawable:N26", setOf(
        ResourceItem(setOf(), "${MD}drawable/N26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-806_775_247)
internal val Res.drawable.N27: DrawableResource by lazy {
      DrawableResource("drawable:N27", setOf(
        ResourceItem(setOf(), "${MD}drawable/N27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_581_418_237)
internal val Res.drawable.N28: DrawableResource by lazy {
      DrawableResource("drawable:N28", setOf(
        ResourceItem(setOf(), "${MD}drawable/N28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_796_073_570)
internal val Res.drawable.N29: DrawableResource by lazy {
      DrawableResource("drawable:N29", setOf(
        ResourceItem(setOf(), "${MD}drawable/N29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_906_815_939)
internal val Res.drawable.N3: DrawableResource by lazy {
      DrawableResource("drawable:N3", setOf(
        ResourceItem(setOf(), "${MD}drawable/N3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-446_516_660)
internal val Res.drawable.N30: DrawableResource by lazy {
      DrawableResource("drawable:N30", setOf(
        ResourceItem(setOf(), "${MD}drawable/N30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(773_644_414)
internal val Res.drawable.N31: DrawableResource by lazy {
      DrawableResource("drawable:N31", setOf(
        ResourceItem(setOf(), "${MD}drawable/N31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_089_496_988)
internal val Res.drawable.N32: DrawableResource by lazy {
      DrawableResource("drawable:N32", setOf(
        ResourceItem(setOf(), "${MD}drawable/N32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_719_436_913)
internal val Res.drawable.N33: DrawableResource by lazy {
      DrawableResource("drawable:N33", setOf(
        ResourceItem(setOf(), "${MD}drawable/N33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-705_284_775)
internal val Res.drawable.N33A: DrawableResource by lazy {
      DrawableResource("drawable:N33A", setOf(
        ResourceItem(setOf(), "${MD}drawable/N33A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(256_834_308)
internal val Res.drawable.N34: DrawableResource by lazy {
      DrawableResource("drawable:N34", setOf(
        ResourceItem(setOf(), "${MD}drawable/N34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_594_213_124)
internal val Res.drawable.N34A: DrawableResource by lazy {
      DrawableResource("drawable:N34A", setOf(
        ResourceItem(setOf(), "${MD}drawable/N34A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-455_073_172)
internal val Res.drawable.N35: DrawableResource by lazy {
      DrawableResource("drawable:N35", setOf(
        ResourceItem(setOf(), "${MD}drawable/N35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_240_981_970)
internal val Res.drawable.N35A: DrawableResource by lazy {
      DrawableResource("drawable:N35A", setOf(
        ResourceItem(setOf(), "${MD}drawable/N35A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-396_326_471)
internal val Res.drawable.N36: DrawableResource by lazy {
      DrawableResource("drawable:N36", setOf(
        ResourceItem(setOf(), "${MD}drawable/N36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_270_257_482)
internal val Res.drawable.N37: DrawableResource by lazy {
      DrawableResource("drawable:N37", setOf(
        ResourceItem(setOf(), "${MD}drawable/N37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-206_844_402)
internal val Res.drawable.N37A: DrawableResource by lazy {
      DrawableResource("drawable:N37A", setOf(
        ResourceItem(setOf(), "${MD}drawable/N37A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_031_619_010)
internal val Res.drawable.N38: DrawableResource by lazy {
      DrawableResource("drawable:N38", setOf(
        ResourceItem(setOf(), "${MD}drawable/N38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(834_374_629)
internal val Res.drawable.N39: DrawableResource by lazy {
      DrawableResource("drawable:N39", setOf(
        ResourceItem(setOf(), "${MD}drawable/N39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-449_179_546)
internal val Res.drawable.N4: DrawableResource by lazy {
      DrawableResource("drawable:N4", setOf(
        ResourceItem(setOf(), "${MD}drawable/N4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_739_324_041)
internal val Res.drawable.N40: DrawableResource by lazy {
      DrawableResource("drawable:N40", setOf(
        ResourceItem(setOf(), "${MD}drawable/N40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(426_264_188)
internal val Res.drawable.N41: DrawableResource by lazy {
      DrawableResource("drawable:N41", setOf(
        ResourceItem(setOf(), "${MD}drawable/N41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-216_868_524)
internal val Res.drawable.N42: DrawableResource by lazy {
      DrawableResource("drawable:N42", setOf(
        ResourceItem(setOf(), "${MD}drawable/N42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-942_472_017)
internal val Res.drawable.N5: DrawableResource by lazy {
      DrawableResource("drawable:N5", setOf(
        ResourceItem(setOf(), "${MD}drawable/N5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(138_972_640)
internal val Res.drawable.N6: DrawableResource by lazy {
      DrawableResource("drawable:N6", setOf(
        ResourceItem(setOf(), "${MD}drawable/N6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_845_597_881)
internal val Res.drawable.N7: DrawableResource by lazy {
      DrawableResource("drawable:N7", setOf(
        ResourceItem(setOf(), "${MD}drawable/N7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-205_464_699)
internal val Res.drawable.N8: DrawableResource by lazy {
      DrawableResource("drawable:N8", setOf(
        ResourceItem(setOf(), "${MD}drawable/N8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-822_523_575)
internal val Res.drawable.N9: DrawableResource by lazy {
      DrawableResource("drawable:N9", setOf(
        ResourceItem(setOf(), "${MD}drawable/N9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(675_732_726)
internal val Res.drawable.NL1: DrawableResource by lazy {
      DrawableResource("drawable:NL1", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_797_754_864)
internal val Res.drawable.NL10: DrawableResource by lazy {
      DrawableResource("drawable:NL10", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_616_585_984)
internal val Res.drawable.NL11: DrawableResource by lazy {
      DrawableResource("drawable:NL11", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-55_092_570)
internal val Res.drawable.NL12: DrawableResource by lazy {
      DrawableResource("drawable:NL12", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(649_502_044)
internal val Res.drawable.NL13: DrawableResource by lazy {
      DrawableResource("drawable:NL13", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(438_245_943)
internal val Res.drawable.NL14: DrawableResource by lazy {
      DrawableResource("drawable:NL14", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-556_623_936)
internal val Res.drawable.NL15: DrawableResource by lazy {
      DrawableResource("drawable:NL15", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(529_981_046)
internal val Res.drawable.NL16: DrawableResource by lazy {
      DrawableResource("drawable:NL16", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_125_667_644)
internal val Res.drawable.NL17: DrawableResource by lazy {
      DrawableResource("drawable:NL17", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(393_557_687)
internal val Res.drawable.NL17a: DrawableResource by lazy {
      DrawableResource("drawable:NL17a", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL17a.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-622_817_229)
internal val Res.drawable.NL18: DrawableResource by lazy {
      DrawableResource("drawable:NL18", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(311_480_628)
internal val Res.drawable.NL19: DrawableResource by lazy {
      DrawableResource("drawable:NL19", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-953_375_818)
internal val Res.drawable.NL2: DrawableResource by lazy {
      DrawableResource("drawable:NL2", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_022_652_355)
internal val Res.drawable.NL20: DrawableResource by lazy {
      DrawableResource("drawable:NL20", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_091_910_428)
internal val Res.drawable.NL3: DrawableResource by lazy {
      DrawableResource("drawable:NL3", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-83_057_235)
internal val Res.drawable.NL4: DrawableResource by lazy {
      DrawableResource("drawable:NL4", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-449_533_778)
internal val Res.drawable.NL5: DrawableResource by lazy {
      DrawableResource("drawable:NL5", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-623_362_483)
internal val Res.drawable.NL5a: DrawableResource by lazy {
      DrawableResource("drawable:NL5a", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL5a.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_114_242_087)
internal val Res.drawable.NL6: DrawableResource by lazy {
      DrawableResource("drawable:NL6", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL6.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable5Resources(map: MutableMap<String, DrawableResource>) {
  map.put("M26", Res.drawable.M26)
  map.put("M27", Res.drawable.M27)
  map.put("M28", Res.drawable.M28)
  map.put("M28A", Res.drawable.M28A)
  map.put("M29", Res.drawable.M29)
  map.put("M3", Res.drawable.M3)
  map.put("M30", Res.drawable.M30)
  map.put("M31", Res.drawable.M31)
  map.put("M31A", Res.drawable.M31A)
  map.put("M32", Res.drawable.M32)
  map.put("M33", Res.drawable.M33)
  map.put("M33A", Res.drawable.M33A)
  map.put("M33B", Res.drawable.M33B)
  map.put("M34", Res.drawable.M34)
  map.put("M35", Res.drawable.M35)
  map.put("M36", Res.drawable.M36)
  map.put("M37", Res.drawable.M37)
  map.put("M38", Res.drawable.M38)
  map.put("M39", Res.drawable.M39)
  map.put("M3A", Res.drawable.M3A)
  map.put("M4", Res.drawable.M4)
  map.put("M40", Res.drawable.M40)
  map.put("M40A", Res.drawable.M40A)
  map.put("M41", Res.drawable.M41)
  map.put("M42", Res.drawable.M42)
  map.put("M43", Res.drawable.M43)
  map.put("M44", Res.drawable.M44)
  map.put("M5", Res.drawable.M5)
  map.put("M6", Res.drawable.M6)
  map.put("M7", Res.drawable.M7)
  map.put("M8", Res.drawable.M8)
  map.put("M9", Res.drawable.M9)
  map.put("N1", Res.drawable.N1)
  map.put("N10", Res.drawable.N10)
  map.put("N11", Res.drawable.N11)
  map.put("N12", Res.drawable.N12)
  map.put("N13", Res.drawable.N13)
  map.put("N14", Res.drawable.N14)
  map.put("N15", Res.drawable.N15)
  map.put("N16", Res.drawable.N16)
  map.put("N17", Res.drawable.N17)
  map.put("N18", Res.drawable.N18)
  map.put("N18A", Res.drawable.N18A)
  map.put("N18B", Res.drawable.N18B)
  map.put("N19", Res.drawable.N19)
  map.put("N2", Res.drawable.N2)
  map.put("N20", Res.drawable.N20)
  map.put("N21", Res.drawable.N21)
  map.put("N22", Res.drawable.N22)
  map.put("N23", Res.drawable.N23)
  map.put("N24", Res.drawable.N24)
  map.put("N25", Res.drawable.N25)
  map.put("N25A", Res.drawable.N25A)
  map.put("N26", Res.drawable.N26)
  map.put("N27", Res.drawable.N27)
  map.put("N28", Res.drawable.N28)
  map.put("N29", Res.drawable.N29)
  map.put("N3", Res.drawable.N3)
  map.put("N30", Res.drawable.N30)
  map.put("N31", Res.drawable.N31)
  map.put("N32", Res.drawable.N32)
  map.put("N33", Res.drawable.N33)
  map.put("N33A", Res.drawable.N33A)
  map.put("N34", Res.drawable.N34)
  map.put("N34A", Res.drawable.N34A)
  map.put("N35", Res.drawable.N35)
  map.put("N35A", Res.drawable.N35A)
  map.put("N36", Res.drawable.N36)
  map.put("N37", Res.drawable.N37)
  map.put("N37A", Res.drawable.N37A)
  map.put("N38", Res.drawable.N38)
  map.put("N39", Res.drawable.N39)
  map.put("N4", Res.drawable.N4)
  map.put("N40", Res.drawable.N40)
  map.put("N41", Res.drawable.N41)
  map.put("N42", Res.drawable.N42)
  map.put("N5", Res.drawable.N5)
  map.put("N6", Res.drawable.N6)
  map.put("N7", Res.drawable.N7)
  map.put("N8", Res.drawable.N8)
  map.put("N9", Res.drawable.N9)
  map.put("NL1", Res.drawable.NL1)
  map.put("NL10", Res.drawable.NL10)
  map.put("NL11", Res.drawable.NL11)
  map.put("NL12", Res.drawable.NL12)
  map.put("NL13", Res.drawable.NL13)
  map.put("NL14", Res.drawable.NL14)
  map.put("NL15", Res.drawable.NL15)
  map.put("NL16", Res.drawable.NL16)
  map.put("NL17", Res.drawable.NL17)
  map.put("NL17a", Res.drawable.NL17a)
  map.put("NL18", Res.drawable.NL18)
  map.put("NL19", Res.drawable.NL19)
  map.put("NL2", Res.drawable.NL2)
  map.put("NL20", Res.drawable.NL20)
  map.put("NL3", Res.drawable.NL3)
  map.put("NL4", Res.drawable.NL4)
  map.put("NL5", Res.drawable.NL5)
  map.put("NL5a", Res.drawable.NL5a)
  map.put("NL6", Res.drawable.NL6)
}
